import { statsCardMessagesEn } from '../components/StatsCard/locale/en';

export default {
  'dataGrid.errorTitle': 'Error',
  'dataGrid.error': 'An error occurred while fetching data',

  'datagrid.footer.rows.totalRows': 'Total rows: {totalRows}',
  'datagrid.footer.rows.totalRowsFiltered': 'Total rows: {visibleRow} of {totalRows}',

  'dataGrid.overlay.noRows': 'No rows',
  'dataGrid.overlay.noResults': 'No results',

  // messages for DataGridPagination
  'dataGrid.pagination.icon.startOfList': 'Jump to the first page',
  'dataGrid.pagination.icon.previousPage': 'Go to the previous page',
  'dataGrid.pagination.icon.nextPage': 'Go to the next page',
  'dataGrid.pagination.icon.endOfList': 'Jump to the last page',
  'dataGrid.pagination.rows.perPage': 'Rows per page:',
  'dataGrid.pagination.items.current': '{startItem} to {endItem} of {totalItems} rows',
  'dataGrid.pagination.goToPage.page': 'Go to page:',
  'dataGrid.pagination.goToPage.current': 'of {totalPages} pages',

  ...statsCardMessagesEn,
};
